import { BaseBloc } from '@core/utils/bloc';
import { TmAgreementId, TmAgreementResponse } from '@business/entities/tm/TmAgreementResponse';
import { TmAgreementAPI } from '@business/api/tm_agreement';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';

export class TmAgreementBloc extends BaseBloc {
  private readonly agreementRepo = new Repository<TmAgreementResponse>({
    getItemId: item => item.id,
  });

  readonly items$ = this.agreementRepo.items$;

  readonly selectItem = this.agreementRepo.selectItem;

  onReset() {
    this.agreementRepo.reset();
  }

  fetchAgreements = (tmId: string) => {
    return TmAgreementAPI.fetchTmAgreements(tmId).pipe(
      this.agreementRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_tm_agreements_error') }),
    );
  };

  generateAgreement = (tmId: string, templateId: string) => {
    return TmAgreementAPI.createTmAgreement(tmId, templateId).pipe(
      this.agreementRepo.ops.addOne(item => item),
      handleMessage({ type: requestMessage('create_tm_agreement') }),
    );
  };

  deleteAgreement = (id: TmAgreementId) => {
    return TmAgreementAPI.deleteTmAgreement(id).pipe(
      this.agreementRepo.ops.removeOne(() => id),
      handleMessage({ type: requestMessage('delete_tm_agreement') }),
    );
  };
}
